import type { FlowStep } from './companyFormularioTypes';

const DRAFT_VERSION = 1 as const;

export type CompanyFormularioDraft = {
	version: typeof DRAFT_VERSION;
	companyId: string;
	flowStep: FlowStep;
	allForms: Forms.FormWithQuestions[];
	currentFormIndex: number;
	currentQuestionStep: number;
	answers: Record<string, string | null>;
	completedFormTitle: string | null;
	/** Total de formulários no início da sessão (progresso N/M na tela entre forms). */
	totalFormsInSession: number;
	savedAt: number;
};

function storageKey(companyId: string): string {
	return `plumaa:company-formulario:${companyId}`;
}

export function loadCompanyFormularioDraft(
	companyId: string,
): CompanyFormularioDraft | null {
	if (typeof window === 'undefined') return null;
	try {
		const raw = window.localStorage.getItem(storageKey(companyId));
		if (!raw) return null;
		const parsed = JSON.parse(raw) as CompanyFormularioDraft;
		if (
			parsed?.version !== DRAFT_VERSION ||
			parsed.companyId !== companyId
		) {
			return null;
		}
		return parsed;
	} catch {
		return null;
	}
}

export function saveCompanyFormularioDraft(
	draft: CompanyFormularioDraft,
): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(
			storageKey(draft.companyId),
			JSON.stringify({
				...draft,
				version: DRAFT_VERSION,
				savedAt: Date.now(),
			}),
		);
	} catch {
		/* quota / modo privado */
	}
}

export function clearCompanyFormularioDraft(companyId: string): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.removeItem(storageKey(companyId));
	} catch {
		/* ignore */
	}
}
